import ServerError from '../server-error';

export default class InternalServerError extends ServerError {
  public static status = 500;

  constructor(message) {
    super(message);
    this.name = 'InternalServerError';
  }
}
